/**
 *  CORE COMPONENTS
 */
import { React } from 'react';
import ReactDOM from 'react-dom';

Object.assign(window, { React, ReactDOM });
